<template>
    <card :header-content-class="['w-100']" v-if="reservation.pablow_data">        
        <template #header-icon>
            <font-awesome-icon 
                :icon="['fas', 'user-shield']"
                size="lg"
            />
        </template>
        <template #header-content>Optional Travel Insurance</template>
        <template #body>
            <div v-if="reservation" class="mt-3">
                <div class="lx-online-booking-reservation-travel-insurance">
                    <div
                        class="
                            lx-online-booking-reservation-travel-insurance__panel
                        "
                    >
                        <div
                            class="
                                lx-online-booking-reservation-travel-insurance__logos
                            "
                        >
                            <div
                                class="
                                    lx-online-booking-reservation-travel-insurance__csa-logo
                                "
                            >
                                <img
                                    class="
                                        lx-online-booking-reservation-travel-insurance__travel-insured-img
                                    "
                                    src="/static/images/pablow/iTravelInsured_Logo.jpg"
                                />
                            </div>
                            <div
                                class="
                                    lx-online-booking-reservation-travel-insurance__pablow-logo
                                "
                            >
                                <img
                                    class="
                                        lx-online-booking-reservation-travel-insurance__pablow-powered-img
                                    "
                                    src="/static/images/pablow/Pablow_powered.jpg"
                                />
                            </div>
                        </div>
                        <div
                            class="
                                lx-online-booking-reservation-travel-insurance__header
                            "
                        >
                            <strong
                                >Help safeguard your non-refundable trip costs
                                if you have to cancel or interrupt your trip due
                                to a covered reason.</strong
                            >
                        </div>
                        <div
                            class="
                                lx-online-booking-reservation-travel-insurance__radio-buttons
                            "
                        >
                            <b-form-radio
                                class="mb-1"
                                v-model="yesNo"
                                name="yes-no"
                                :value="true"
                            >
                                <span
                                    >Yes, cover my trip cost of
                                    <div
                                        class="
                                            lx-online-booking-reservation-travel-insurance__trip-price-container
                                        "
                                    >
                                        {{ tripPrice }}
                                    </div>
                                    for
                                    <div
                                        class="
                                            lx-online-booking-reservation-travel-insurance__insurance-price
                                        "
                                    >
                                        {{ insurancePrice }}
                                    </div>
                                </span>
                            </b-form-radio>
                            <b-form-radio
                                class="mb-3"
                                v-model="yesNo"
                                name="yes-no"
                                :value="false"
                            >
                                No
                            </b-form-radio>
                        </div>
                        <span
                            class="
                                lx-online-booking-reservation-travel-insurance__note
                            "
                        >
                            Note: Declining insurance may affect your right to a
                            refund, and you will be responsible for any
                            cancellation penalties in accordance with the terms
                            and conditions, up to 100% of the rental cost.
                        </span>
                        <div
                            class="
                                lx-online-booking-reservation-travel-insurance__product-link
                            "
                        >
                            <a
                                target="_blank"
                                href="https://lodgix.pablow.io/Company/Products.aspx"
                                >View the Insurance Policy</a
                            >
                            <span>(opens in new window)</span>
                        </div>
                        <div
                            v-if="yesNo"
                            class="
                                lx-online-booking-reservation-travel-insurance__buy-button-container
                            "
                        >
                            <div
                                class="
                                    lx-online-booking-reservation-travel-insurance__buy-button
                                "
                            >
                                <b-button
                                    @click="buyNow"
                                    :disabled="!yesNo"
                                    size="lg"
                                    variant="primary"
                                >
                                    Buy Now
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else></div>
        </template>
    </card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '../../../generic/card/card.vue';
import { toAmountDisplay } from '../../../../utils/numbers.js';

export default {
    name: 'OnlineBookingReservationOptionalTravelInsurance',
    components: { Card },
    computed: {
        ...mapGetters('onlineBooking', ['reservation']),
        tripPrice() {
            if (this.reservation) {
                return this.reservation.pablow_data.originalCurrencyCode ==
                    'USD'
                    ? toAmountDisplay({
                          amount:
                              this.reservation.pablow_data
                                  .guestTravelCostInCents / 100,
                          currency: '$',
                      })
                    : `${toAmountDisplay({
                          amount:
                              this.reservation.pablow_data.originalTotal / 100,
                          currency:
                              this.reservation.pablow_data
                                  .originalCurrencyCode + ' ',
                      })} (${toAmountDisplay({
                          amount:
                              this.reservation.pablow_data
                                  .guestTravelCostInCents / 100,
                          currency: 'USD ',
                      })})`;
            }
            return '';
        },
        insurancePrice() {
            if (this.reservation) {
                return toAmountDisplay({
                    amount:
                        (this.reservation.pablow_data.guestTravelCostInCents /
                            100) *
                        0.0695,
                    currency:
                        this.reservation.pablow_data.originalCurrencyCode ==
                        'USD'
                            ? '$'
                            : 'USD ',
                });
            }
            return '';
        },
    },
    data() {
        return {
            loading: false,
            yesNo: true,
        };
    },
    methods: {
        buyNow() {
            if (!this.reservation.pablow_data) {
                this.reservation.pablow_data = {
                    guestTravelCostInCents: '', // Required: Enter cost of room in cents. if rental cost was $1280.36, then enter "128036". Do not include any fees that are not associated with rental i.e. security deposit, etc
                    guestTravelBeginDate: '', // Required: Enter start date of trip in YYYYMMDD format - example: "20150422"
                    guestTravelEndDate: '', // Required: Enter end date of trip in YYYYMMDD format - example: "20150428"
                    guestFirstName: '', // Optional: Enter guest's first name - example: "John" ; otherwise leave it as is
                    guestLastName: '', // Optional: Enter guest's last name - example: "Doe" ; otherwise leave it as is
                    guestAge: '', // Optional: Enter guest's age - example: "36" ; otherwise leave it as is
                    guestAddressLine1: '', // Optional: Enter guest's first address line - example: "123 Walnut St Suite 250" ; otherwise leave it as is
                    guestAddressLine2: '', // Optional: Enter guest's second address line - example: "5th Floor" ; otherwise leave it as is
                    guestCity: '', // Optional: Enter guest's city - example: "Boston" ; otherwise leave it as is
                    guestState: '', // Optional: Enter guest's two digit state code - example: "MA" ; otherwise leave it as is
                    guestPostalCode: '', // Optional: Enter guest's five digit zip code - example: "63201" ; otherwise leave it as is
                    guestCountry: '', // Optional: Currently only US is accepted - example: "US"
                    guestPhone: '', // Optional: Enter guest's ten digit phone number - example: "5558023611" ; otherwise leave it as is
                    guestEmail: '', // Optional: Enter guest's email address - example: "john.doe@gmail.com" ; otherwise leave it as is
                    guestNameOnCreditCard: '', // Optional: Enter guest's full name as it appears on credit card : "John M. Doe" ; otherwise leave it as is
                    guestCreditCardBillingZipCode: '', // Optional: Enter guest's five digit credit card billing zip code - example: "05421" ; otherwise leave it as is
                    transactionId: '', // Required: Enter a unique identifier for this transaction - example: "123456789ABC"
                    referringPartner: '', // Required: This must be the name of the company refering to pablow for travel insurance - i.e. you. This can be anything you choose but must indicate the affliation and must always be the same. - example: "Lodgix"
                };
            }

            //This IF statement is used for error handling. It still redirects to the Pablow payment page if no values are loaded into the dictionary.
            if (
                this.reservation.pablow_data.valueOf == 0 ||
                this.reservation.pablow_data.valueOf == null
            ) {
                var linkToRedirect = '';
                if (window.location.hostname.toString() == 'localhost') {
                    linkToRedirect = 'http://localhost:53390/Redirect.aspx';
                } else if (
                    window.location.hostname.toString() ==
                    'asynctestinginnovo.azurewebsites.net'
                ) {
                    linkToRedirect =
                        'http://asynctestinginnovo.azurewebsites.net/Redirect.aspx';
                } else {
                    linkToRedirect = 'https://lodgix.pablow.io/Redirect.aspx';
                }
                window.open(linkToRedirect, '_blank');
            }
            //This ELSE statement takes all values loaded into the dictionary and, with the FOR loop, parses it to xml for the
            //redirect to the Pablow payment page. The variable linkToAppend contains the link to the Pablow payment page.
            //The variable runningInputs is used to store all the XML parsed statements. If is appended to with the FOR loop.
            else {
                //in order to determine where to link to, get the current Url. this logic is used for testing
                var linkToAppend = '';
                if (window.location.hostname.toString() == 'localhost') {
                    linkToAppend = 'http://localhost:53390/Redirect.aspx';
                } else if (
                    window.location.hostname.toString() ==
                    'asynctestinginnovo.azurewebsites.net'
                ) {
                    linkToAppend =
                        'http://asynctestinginnovo.azurewebsites.net/Redirect.aspx';
                } else {
                    linkToAppend = 'https://lodgix.pablow.io/Redirect.aspx';
                }
                var runningInputs = '';
                var i = 0;
                for (var keyInDictionary in this.reservation.pablow_data) {
                    var valueInDictionary =
                        this.reservation.pablow_data[keyInDictionary];
                    if (i === 0) {
                        runningInputs =
                            runningInputs +
                            '?' +
                            keyInDictionary +
                            '=' +
                            valueInDictionary;
                    } else {
                        runningInputs =
                            runningInputs +
                            '&' +
                            keyInDictionary +
                            '=' +
                            valueInDictionary;
                    }
                    i++;
                }
                var finalLink = linkToAppend + runningInputs;
                window.open(finalLink, '_blank');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

.lx-online-booking-reservation-travel-insurance {
    &__panel {
        position: relative;
    }
    &__logos {
        position: relative;
        float: right;
        width: 97px;
        height: 116px;
    }
    &__csa-logo {
        height: 48px;
        width: 95px;
        top: 19px;
        float: right;
    }
    &__pablow-logo {
        height: 48px;
        width: 95px;
        margin-top: 18px;
        float: right;
    }
    &__header {
        width: 85%;
        position: relative;
        margin-top: -10px;
    }
    &__radio-buttons {
        width: 85%;
        position: relative;
        padding-top: 18px;
    }
    &__trip-price-container {
        width: auto;
        position: relative;
        display: inline;
        padding-left: 6px;
        margin-right: 6px;
        font-weight: bold;
    }
    &__insurance-price {
        width: 70px;
        position: relative;
        display: inline;
        font-weight: bold;
        padding-left: 6px;
    }
    &__product-link {
        width: 100%;
        position: relative;
        margin-top: 18px;

        a {
            color: #36aae1;
        }
        span {
            font-size: smaller;
        }
    }
    &__buy-button-container {
        width: 100%;
        position: relative;
    }
    &__buy-button {
        float: right;
        display: inherit;
    }
    &__travel-insured-img {
        width: 100px;
    }
    &__pablow-powered-img {
        width: 100px;
    }
    &__note {
        display: inline-block;
        max-width: 800px;
        color: black;
    }
}
</style>
